<template>
  <div v-loading="loading" element-loading-spinner="atom-audit-loader">
    <div v-for="(group) in allData" :key="group.key" style="margin-top: 30px; margin-bottom:20px;">
      <h3>{{group.key}}</h3>

      <table class="hiaTable" style="margin-top: 20px;">
        <thead>
          <tr>
            <th> Facility </th>
            <th> Total Records </th>
            <th> Total APCs </th>
            <th> APCs wo Query Rec. </th>
            <th>Total Codes</th>
            <th>ICD-10 CM Codes</th>
            <th v-if="tenantSetup.enableOutpatientPcsAuditing">ICD-10 PCS Codes</th>
            <th>CPT Codes</th>
            <th>Modifier Codes</th>
            <th>E/M Codes</th>
            <th>I&I Codes</th>
            <th>S&I Codes</th>
            <th>Financial Impact</th>
          </tr>
        </thead>
        <tr v-for="item in group.data" :key="item.key">
          <td class="textAlignLeft"> {{item.cliName}} </td>
          <td> {{item.totalRecords}} </td>
          <td> {{formatPercentage(item.apcCodes)}} </td>
          <td> {{formatPercentage(item.apcCodeswoQuery)}} </td>
          <td> {{formatPercentage(item.totalCodes)}} </td>
          <td> {{formatPercentage(item.cmCodes)}} </td>
          <td v-if="tenantSetup.enableOutpatientPcsAuditing"> {{formatPercentage(item.pcsCodes)}} </td>
          <td> {{formatPercentage(item.cptCodes)}} </td>
          <td> {{formatPercentage(item.modCodes)}} </td>
          <td> {{formatPercentage(item.emCodes)}} </td>
          <td> {{formatPercentage(item.iiCodes)}} </td>
          <td> {{formatPercentage(item.siCodes)}} </td>
          <td :class="`${item.financialImpact < 0 ? 'negative' : ''}`"> {{item.financialImpact}}</td>
        </tr>
        <tr class="strong emphasis">
          <td class="textAlignLeft">Total</td>
          <td>{{getSummaries(group.data)[1]}}</td>
          <td>{{getSummaries(group.data)[2]}}</td>
          <td>{{getSummaries(group.data)[3]}}</td>
          <td>{{getSummaries(group.data)[4]}}</td>
          <td>{{getSummaries(group.data)[5]}}</td>
          <td v-if="tenantSetup.enableOutpatientPcsAuditing">{{getSummaries(group.data)[6]}}</td>
          <td>{{getSummaries(group.data)[7]}}</td>
          <td>{{getSummaries(group.data)[8]}}</td>
          <td>{{getSummaries(group.data)[9]}}</td>
          <td>{{getSummaries(group.data)[10]}}</td>
          <td>{{getSummaries(group.data)[11]}}</td>
          <td :class="`${getSummaries(group.data)[12] < 0 ? 'negative' : ''}`">{{getSummaries(group.data)[12]}}</td>
        </tr>
      </table>
    </div>

  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import axios from '@/utilities/axios-global'
  import hiaFilters from '@/mixins/hiaFilters'
  import money from '@/mixins/money'
  import dashboardHelper from '@/mixins/dashboardHelper'

  export default {
    name: 'OP_ByFacilityPrintable',
    mixins: [hiaFilters, money, dashboardHelper],
    props: ['ascTableIds', 'codeTypes'],
    components: {
    },
    data: function () {
      return {
        allData: [],
        tableData: [],
        filterCriteria: '',
        loading: false,
        summaryRow: {},
        detailsHeader: ''
      }
    },
    methods: {
      async getData() {
        const payload = {
          ascTableIds: this.ascTableIds,
          codeTypes: this.codeTypes,
          includeAccts: true,
          statType: 'test'
        }
        try {
          this.loading = true
          const response = await axios.post(`${this.baseApiUrl}/reports/dashboard/opByFacility`, payload)
          this.allData = response.data.data
          this.tableData = response.data.data
        } catch (err) {
          this.allData = []
          this.tableData = []
        } finally {
          this.$nextTick(() => {
            // this.$refs.dxTable.doLayout()
            this.loading = false
          })
        }
      },
      getSummaries(data) {
        const param = {
          columns: [
            { property: 'cliName' },
            { property: 'totalRecords' },
            { property: 'apcCodes' },
            { property: 'apcCodeswoQuery' },
            { property: 'totalCodes' },
            { property: 'cmCodes' },
            { property: 'pcsCodes' },
            { property: 'cptCodes' },
            { property: 'modCodes' },
            { property: 'emCodes' },
            { property: 'iiCodes' },
            { property: 'siCodes' },
            { property: 'financialImpact' }
          ],
          data: data
        }
        return this.getSummary(param)
      },
      cellClasses({ row, column, rowIndex, columnIndex }) {
        if (column.property === 'code' || column.property === 'description' || column.property === 'codeDesc') {
          return 'textAlignLeft'
        }
        if (column.property === 'details') {
          return 'textAlignCenter'
        }
      }
    },
    computed: {
      ...mapState('user/', ['baseApiUrl']),
      ...mapState('managedLists/tenantSetup/', ['tenantSetup'])
    },
    mounted: async function () {
      await this.getData()
    },
    watch: {
      ascTableIds: async function () {
        await this.getData()
      },
      codeTypes: async function () {
        await this.getData()
      }
    }
  }
</script>

<style scoped>
.totalsTable {
  border-spacing: 0px;
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
}

.totalsTable td {
  padding: 13px;
}
</style>
